<template>
    <div class="evaluation-intro-section">
        <div class="container">
            <div class="intro-row">
                <div class="intro-left">
                    <img src="@/assets/images/t2.png"
                         alt="中物鉴智科技成果评价机构简介"
                         class="intro-image">
                </div>
                <div class="intro-right">
                    <div class="content-block">
                        <h3 class="block-title">评价机构简介</h3>
                        <p style="font-size: 22px;line-height: 44px;" class="block-text">
                            中物鉴智（成都）科技成果评价有限公司是全国科技评估与管理研究会会员单位，承担了多项国家标准的试点工作。完成地方政府、高校、科研院所、央国企及民营头部企业的成果评价、概念验证、技术评估、验收结题、奖励培育等服务超1000项；“岷山行动”“江源行动”等重大项目的投前尽调、投后管理、验收评估超100项；清华大学、北京大学等高层次人才项目的技术评估与场景验证超50项；国家电网、中国石油、蜀道集团等央国企的“揭榜挂帅”超20项。评价项目获国家、省部级科技进步奖超100项，企业上市、上板、上新超40家。

                        </p>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;background: #f8f9fa;" class="intro-row">
                <div   style="align-items: center;flex: 1;display: flex;background: #fff;border-radius: 10px;">
                    <!-- <div class="content-block">
                        <h3 class="block-title">成果评价</h3>
                        <p class="block-text">
                        <div style="background: #f8f9fa;" class="stats-module">
                            <div class="stat-item">
                                <div class="stat-number">深耕</div>
                                <div class="stat-label">8年+</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">已累计组织500+场</div>
                                <div class="stat-label">成果评价</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">10000+评价专家</div>
                                <div class="stat-label">专家</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">拥有合作伙伴100+位</div>
                                <div class="stat-label">合作伙伴</div>
                            </div>
                        </div>
                        </p>
                    </div> -->
                    <!-- <img src="@/assets/images/shuo.png" style="width: 100%;"> -->
                     <anlie></anlie>
                </div>
                <div class="intro-left">
                    <img src="@/assets/images/t1.jpg"
                         alt="科技成果评价案例与服务场景"
                         class="intro-image">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anlie from './anlie.vue';
export default {
    name: 'EvaluationIntro',
    props: {},
    data() {
        return {}
    },
    components: {
       anlie
    },
}
</script>

<style scoped>
.evaluation-intro-section {
    background: #fff;
}

.container {
    margin: 0 auto;
    max-width: 1400px;
}

.intro-row {
    display: flex;
    gap: 2.5rem;
    align-items: stretch;
}

.intro-left {
    flex: 1;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.intro-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    object-position: center;
    height: 400px;
}

.intro-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.5rem;
}

.content-block {
    background: white;
    padding: 1.8rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border-left: 4px solid #4169e1;
    transition: transform 0.3s, box-shadow 0.3s;
    height: 100%;
}

.content-block:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.block-title {
    color: #4169e1;
    font-size: 2.0rem;
    font-weight: 600;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.block-title::before {
    content: '';
    width: 4px;
    height: 32px;
    background: #4169e1;
    border-radius: 2px;
}

.block-text {
    color: #666;
    line-height: 2.2;
    font-size: 0.95rem;
    margin: 0;
}

@media (max-width: 768px) {
    .intro-row {
        flex-direction: column;
    }

    .intro-left {
        height: 250px;
    }

    .intro-right {
        gap: 1rem;
    }

    .content-block {
        padding: 1.2rem;
    }
}

@media (max-width: 576px) {
    .evaluation-intro-section {
        padding: 40px 0;
    }

    .block-title {
        font-size: 1.1rem;
    }

    .block-text {
        font-size: 0.9rem;
    }
}

.stats-module {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    background: #f8f9fa;
}

.stat-item {
    text-align: center;
    flex: 1;
    margin: 0 10px;
}

.stat-number {
    font-size: 30px;
    font-weight: 900;
    color: #333;
    margin-bottom: 8px;
}

.stat-label {
    font-size: 1.5rem;
    color: #666;
}
@media (max-width: 768px) {
    .stats-module {
        flex-wrap: wrap;
    }

    .stat-item {
        flex: 0 0 50%;
        margin-bottom: 15px;
    }

    .stat-number {
        font-size: 1.6rem;
    }
}

@media (max-width: 576px) {
    .stat-item {
        flex: 0 0 100%;
    }
}
</style>